import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { PlannerV2AreaGetByIdDocument, PlannerV2AreaGetByIdQueryVariables } from "./queries.generated";

export default function usePlannerV2AreaGetById(params: PlannerV2AreaGetByIdQueryVariables) {
    const { data, loading, error, previousData } = useQuery(PlannerV2AreaGetByIdDocument, {
        variables: params,
        fetchPolicy: "cache-and-network",
    });

    const area = useMemo(() => {
        return data?.plannerV2AreaGetById ?? previousData?.plannerV2AreaGetById;
    }, [data, previousData]);

    return {
        area,
        loading,
        error,
    };
}
